import Login from '@/components/views/Login'
import Page404 from '@/components/views/404'
import axios from 'axios'
import Vue from 'vue'
import Router from 'vue-router'
import store from '../../store'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: Login,
      meta: { title: 0, titleText: 'Webiomed' }
    },
    {
      path: '*',
      redirect: () => {
        if (!store.state.user.isAuthenticated) {
          return { name: 'Login' }
        } else {
          return { name: 'Page404' }
        }
      }
    },
    {
      name: 'Root',
      path: '/',
      component: () => import('@/components/views/Root'),
      redirect: () => {
        if (!store.state.user.isAuthenticated) {
          return { name: 'Login' }
        } else return { name: 'Main' }
      },
      children: [
        // MENUS
        // 1 - the title of page
        {
          name: 'Main',
          path: 'main',
          component: () => import('@/components/views/Main'),
          meta: { title: 0, titleText: 'Главная' }
        },
        {
          name: 'Analysis',
          path: 'analysis',
          component: () => import('@/components/views/Analysis'),
          meta: { title: 0, titleText: 'Анализ данных пациента' }
        },
        {
          name: 'Analytics',
          path: 'analytics',
          component: () => import('@/components/views/Analytics'),
          meta: { title: 0, titleText: 'Аналитика' }
        },
        {
          name: 'Administration',
          path: 'administration',
          component: () => import('@/components/views/Administration'),
          meta: { title: 0, titleText: 'Администрирование' }
        },

        // REQUESTS
        {
          name: 'Requests',
          path: 'requests',
          component: () => import('@/components/views/Requests'),
          meta: { title: 0, titleText: 'Запросы' }
        },
        {
          name: 'RequestSummary',
          path: 'requests/:id/:api_version',
          component: () => import('@/components/views/RequestSummary'),
          meta: { title: 2, titleText: 'Запрос №' },
          props: (route) => ({ id: route.query.id, api_version: route.query.api_version })
        },
        // {
        //   name: 'RequestSummary',
        //   path: 'requests/:id',
        //   component: () => import('@/components/views/RequestSummary'),
        //   meta: { title: 2, titleText: 'Запрос №' }
        // },
        {
          name: 'RequestCaseSummary',
          path: 'requests/:id/:external_id/:api_version',
          component: () => import('@/components/views/RequestCaseSummary'),
          meta: { title: 1, titleText: '' },
          props: (route) => ({ api_version: route.query.api_version || 'v2' })
        },
        {
          name: 'AnalysisSummary',
          path: 'analysis-summary/:id',
          component: () => import('@/components/views/AnalysisSummary'),
          meta: { title: 2, titleText: 'Результаты запроса № ' }
        },
        {
          name: 'BackReports',
          path: 'back-reports',
          component: () => import('@/components/views/BackReports'),
          meta: { title: 0, titleText: 'Обратная связь' }
        },
        {
          name: 'BackReportSummary',
          path: 'report-summary/:id',
          component: () => import('@/components/views/BackReportSummary'),
          meta: { title: 2, titleText: 'Запрос №' }
        },

        // DOCUMENTS

        {
          name: 'DocumentSummary',
          path: 'document/:id/:doc_id',
          component: () => import('@/components/views/DocumentSummary'),
          props: (route) => ({ id: route.query.id, doc_id: route.query.doc_id, external_id: route.query.external_id })
        },
        {
          name: 'DocumentCaseSummary',
          path: 'document/:id/:external_id/:type',
          component: () => import('@/components/views/DocumentSummary')
        },

        // STATISTICS
        {
          name: 'Statistics',
          path: 'statistics',
          component: () => import('@/components/views/Statistics'),
          meta: { title: 0, titleText: 'Статистика' }
        },
        {
          name: 'StatisticsView',
          path: 'statistics-view/:id',
          component: () => import('@/components/views/StatisticsView'),
          meta: { title: 1, titleText: '' }
        },

        // DIRECTORIES
        {
          name: 'NSI',
          path: 'directories',
          component: () => import('@/components/views/NSI'),
          meta: { title: 0, titleText: 'Справочники' }
        },
        {
          name: 'DirectorySummary',
          path: 'directory-summary/:id',
          component: () => import('@/components/views/DirectorySummary'),
          meta: { title: 1, titleText: '' }
        },
        {
          name: 'DirectoryEdit',
          path: 'directory/:parentID/edit/:alias/:id',
          component: () => import('@/components/views/DirectoryEdit'),
          meta: { title: 1, titleText: 'Редактирование справочника' }
        },

        // REQUEST LOGS
        {
          name: 'RequestLogs',
          path: 'request-logs',
          component: () => import('@/components/views/RequestLogs'),
          meta: { title: 0, titleText: 'Журнал запросов' }
        },
        {
          name: 'LogSummary',
          path: 'log-summary/:id',
          component: () => import('@/components/views/LogSummary'),
          meta: { title: 2, titleText: 'Запрос №' }
        },
        {
          name: 'Settings',
          path: 'settings',
          component: () => import('@/components/views/Settings'),
          meta: { title: 0, titleText: 'Настройки' }
        },
        {
          name: 'AdminPannel',
          path: 'admin-panel',
          component: () => import('@/components/views/AdminPannel'),
          meta: { title: 0, titleText: 'Aдминистративные панели сервисов' }
        },

        // USER GROUPS
        // {
        //   name: 'UserGroups',
        //   path: 'user-groups',
        //   component: () => import('@/components/views/UserGroups'),
        //   meta: { title: 0, titleText: 'Группы доступа' }
        // },
        // {
        //   name: 'UserGroupAdd',
        //   path: 'user-group-add',
        //   component: () => import('@/components/views/UserGroupAdd'),
        //   meta: { title: 0, titleText: 'Новая группа доступа' }
        // },
        // {
        //   name: 'UserGroupSummary',
        //   path: 'user-group/:id',
        //   component: () => import('@/components/views/UserGroupSummary'),
        //   meta: { title: 1, titleText: '' }
        // },
        // {
        //   name: 'UserGroupChange',
        //   path: 'user-group-change/:id',
        //   component: () => import('@/components/views/UserGroupChange'),
        //   meta: { title: 0, titleText: 'Редактирование группы доступа ' }
        // },

        // USERS
        {
          name: 'Users',
          path: 'users',
          component: () => import('@/components/views/Users'),
          meta: { title: 0, titleText: 'Учетные записи' }
        },
        {
          name: 'UserAdd',
          path: 'user-add',
          component: () => import('@/components/views/UserAdd'),
          meta: { title: 0, titleText: 'Новая учетная запись' }
        },
        {
          name: 'UserSummary',
          path: 'user/:id',
          component: () => import('@/components/views/UserSummary'),
          meta: { title: 1, titleText: '' }
        },

        // INFORMATION
        {
          name: 'SystemUsageInforamation',
          path: 'system-information',
          component: () => import('@/components/views/SystemUsageInforamation'),
          meta: {
            requiresAuth: false,
            title: 0,
            titleText: 'Информация об использовании системы'
          }
        },
        // MODEL COVID-19
        {
          name: 'PredictCovid',
          path: 'predict-covid',
          component: () => import('@/components/views/PredictCovid')
        },
        // DASHBOARDS
        {
          name: 'DashboardsCovid',
          path: 'dashboards-covid',
          component: () => import('@/components/views/DashboardsCovid')
        }
      ]
    },
    {
      name: 'Page404',
      path: '/pages/404',
      component: Page404,
      meta: { title: 0, titleText: 'Webiomed' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (
    to.name === 'Login' ||
    store.state.user.isAuthenticated ||
    to.query.t ||
    !to.meta.requiresAuth
  ) {
    if (to.query.t) {
      axios.defaults.headers.common.Authorization = 'JWT ' + to.query.t

      store
        .dispatch('authorizeToken', {
          token: to.query.t
        })
        .catch(error => { this.error = true })
    } else {
      if (localStorage.getItem('Token')) {
        axios.defaults.headers.common.Authorization = 'JWT ' + localStorage.getItem('Token')
      }
    }
    switch (to.meta.title) {
      case 1:
        break
      case 2:
        document.title = to.meta.titleText + (to.params.id ? to.params.id : '')
        break
      case 0:
        document.title = to.meta.titleText
        break
      default:
        document.title = 'Webiomed'
        break
    }

    if (to.hash.includes('#!/patient-analysis-request/')) {
      let params = new URLSearchParams(to.hash.slice(29))
      next({
        name: 'Analysis',
        query: {
          t: params.get('t')
        }
      })
    }
    if (to.hash.includes('#!/analysis-requests-summary/')) {
      let queryString = to.hash.slice(29)
      let id = queryString.split('?')[0] // GET ID
      let tokenString = queryString.split('?')[1] // GET TOKEN

      let params = new URLSearchParams(tokenString)

      next({
        name: 'AnalysisSummary',
        params: {
          id
        },
        query: {
          t: params.get('t')
        }
      })
    } else next()
  } else {
    next({ name: 'Login' })
  }
})

export default router
